import { styled } from '@linaria/react';

import {
  DemoRadioControl,
  DemoSliderControl,
} from '@/components/Demo';

import FlexDemo from './FlexDemo';
import Output from './Output';

function GapHeader() {
  return (
    <FlexDemo
      initialValues={{
        '--justify': 'center',
        '--align-items': 'center',
        gap: 16,
      }}
      controls={[
        <DemoRadioControl
          key="--justify"
          id="--justify"
          label="justify-content"
          options={['flex-start', 'center', 'flex-end']}
        />,
        <DemoSliderControl
          key="gap"
          id="gap"
          label="gap"
          min={0}
          max={64}
          previewRenderer={(val) => `${val}px`}
        />,
      ]}
    >
      {({ gap, ...state }) => {
        return (
          <Output
            state={{ ...state, '--gap': `${gap}px` }}
            height={100}
            wrapperStyle={{ padding: 32 }}
          >
            <NavLink href="">Home</NavLink>
            <NavLink href="">Shop</NavLink>
            <NavLink href="">Contact</NavLink>
          </Output>
        );
      }}
    </FlexDemo>
  );
}

const NavLink = styled.a`
  font-size: 1.125rem;
  font-weight: bold;
  color: var(--color-text);
  text-decoration: none;
`;

export default GapHeader;
